import { Page } from '@/core/architecture'

import { ResaleDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleDetail Page
 * Implemented as a practical sample.
 */
export const ResaleDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleDetailTemplate state={state} {...actions} />
}
